module.exports = __webpack_public_path__ + "videos/esfira-mob.cf2daee.mp4";